import React from 'react'
import { useRef } from 'react';
import DropdownManagementFormData from './dataFile/DropdownmanagementForm.data';
import { useState } from 'react';
import SwalAlert from '../../../services/swalService/SwalService';
import FormCreator from '../../../components/forms/FormCreator';
import FinalMolGrid from '../../../components/FinalMolGrid/FinalMolGrid';
import { DropdownListConfig } from './dataFile/DropdownListConfig';
import { useAddEditDropdownDataMutation, useDeleteDropdowndataMutation, useGetDropdownRecordListMutation, useLazyGetDropdownDatabyIdQuery } from '../../../app/services/FieldManagement/DropdownManagement/DropdownManagementApi';
import { useEffect } from 'react';
import { setAllDropDownFieldsBatch } from '../../../utils/FormFields/FieldsSetting/SetFieldSetting';
import DataLoader from '../../../components/FinalMolGrid/ui/dataLoader/DataLoader';
import Buttons from '../../../components/ui/button/Buttons';
import { getAuditContext } from '../../../lib/authenticationLibrary';

const DropdownManagementFeature = () => {
    const { success, error, confirm } = SwalAlert()
    const audit = getAuditContext();
    const [selectedDropdownId, setSelectedDropDownId] = useState();
    const [isShowAdd, setIsShowAdd] = useState(false);
    const DropDownSelectRef = useRef();
    const [DropdownManagementForm, setDropdownManagementFormData] = useState(DropdownManagementFormData);
    const [dropdownSelected, setDropdownSelected] = useState(null);

    const [getDropdownRecordList, { isSuccess: isSuccessDropdown, isFetching: isFetchingDropdown, data: dropdownResponseData }] = useGetDropdownRecordListMutation();
    const [getDropdownDatabyId, { isSuccess: isSuccessDropdownById, isFetching: isFetchingDropdownById, data: dropdownByIdResponse }] = useLazyGetDropdownDatabyIdQuery();
    const [addEditDropdown, { isSuccess: isSuccessAddEditDropdown, isFetching: isFetchingAddEditDropdown, data: addEditDropdownResponse }] = useAddEditDropdownDataMutation();
    const [deleteDropdowndata, { isSuccess: isSuccessDeleteDropdowndata, data: deleteDropdowndataResponse }] = useDeleteDropdowndataMutation();

    //List API integratation
    useEffect(() => { getDropdownRecordList() }, [])

    //set Dropdown response integratation
    useEffect(() => {
        if (!isFetchingDropdown && isSuccessDropdown && dropdownResponseData) {
            const field = DropdownManagementFormData.section[0].rowGroup[0].fields.find(field => field.id === "dropdownManagement");
            field.fieldSetting.options = dropdownResponseData.map(obj => ({ value: obj.id, label: obj.name }));
            setAllDropDownFieldsBatch(DropdownManagementFormData, dropdownResponseData);
        }
    }, [isFetchingDropdown, isSuccessDropdown, dropdownResponseData]);

    //get by Id API integratation
    useEffect(() => {
        if (!isFetchingDropdownById && isSuccessDropdownById && dropdownByIdResponse) {
            setDropdownSelected(dropdownByIdResponse)
        }
    }, [isFetchingDropdownById, isSuccessDropdownById, dropdownByIdResponse]);

    //AddEdit API integratation
    useEffect(() => {
        if (!isFetchingAddEditDropdown && isSuccessAddEditDropdown && addEditDropdownResponse) {
            if (addEditDropdownResponse.hasError === false) {
                success("Dropdown update Successfully")
                getDropdownDatabyId(selectedDropdownId)
            }
            else {
                error(addEditDropdownResponse.errorMessage)
            }
        }
    }, [isFetchingAddEditDropdown, isSuccessAddEditDropdown, addEditDropdownResponse]);

    //delete API integration
    useEffect(() => {
        if (isSuccessDeleteDropdowndata && deleteDropdowndataResponse && !deleteDropdowndataResponse.hasError) {

            getDropdownDatabyId(selectedDropdownId);
            success("Dropdown deleted successfully");

        } else if (deleteDropdowndataResponse?.hasError) {
            error(deleteDropdowndataResponse.errorMessage);
        }
    }, [isSuccessDeleteDropdowndata, deleteDropdowndataResponse]);

    const onDropDownChange = (data) => {
        const { value } = data.dropdownManagement
        setSelectedDropDownId(value);
        setIsShowAdd(true);
        getDropdownDatabyId(value)
    }

    const handleAdd = () => {
        if (!dropdownSelected) {
            return false
        }
        let temp = [...dropdownSelected]
        let valueOrdering = (dropdownSelected[dropdownSelected.length - 1].valueOrdering)
            ? (dropdownSelected[dropdownSelected.length - 1].valueOrdering) + 1 : null
        temp.push({
            id: 0,
            name: "",
            valueOrdering: valueOrdering
        })
        setDropdownSelected(temp)
    }

    const handleSave = (data) => {
        const request = {
            DropdownId: selectedDropdownId,
            TabelDataId: data.id ? data.id : 0,
            Name: data.name ? data.name.replace(/'/g, "''") : "",  // Escape single quotes
            ValueOrdering: parseInt(data.valueOrdering) ? parseInt(data.valueOrdering) : "",
            CreatedBy: audit.adminUserId,
            CreatedAppId: audit.appId,
        };

        addEditDropdown(request);
    }

    const handleDelete = (data) => {
        confirm('Delete', "Are you sure you want to delete", 'Yes', 'Cancel')
            .then(value => {
                if (value) {
                    const request = {
                        TabelDataId: data.id,
                        Id: selectedDropdownId,
                        deletedBy: audit.adminUserId,
                        appId: audit.appId
                    }
                    deleteDropdowndata(request)
                }
            })
    }
    const actionHandler = {
        SAVE: handleSave,
        DELETE: handleDelete,
    }
    const onRowDataUpdate = (updateData, rowIndexToUpdate) => {
        handleSave(updateData);
    }
    return (
        <>
            {dropdownResponseData ?
                <div className='vertical-form'>
                    <FormCreator
                        config={DropdownManagementForm}
                        ref={DropDownSelectRef}
                        key={false}
                        onFormDataChange={onDropDownChange}
                    />
                    <div className={`d-flex justify-content-end mb-4 align-items-end`}>
                        <Buttons
                            buttonText="+ Add New"
                            buttonTypeClassName="theme-btn btn mt-5"
                            onClick={handleAdd}

                        />
                    </div>
                </div>
                :
                <DataLoader />
            }
            <FinalMolGrid
                ref={DropDownSelectRef}
                configuration={DropdownListConfig}
                dataSource={dropdownSelected}
                allowPagination={false}
                onActionChange={actionHandler}
                isLoading={isFetchingDropdownById}
                allowAddGridItem={true}
                onRowDataUpdate={onRowDataUpdate}
            />


        </>
    )
}

export default DropdownManagementFeature

